import React, { useRef, useEffect, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import debounce from 'lodash/debounce';

// COMPONENTE
import ReactAsyncSelect from '~/components/ReactSelect/async';

// BOOTSTRAP
import Row from '~/components/Bootstrap/Row';
import { ColSm12 } from '~/components/Bootstrap/Col';

// STYLED COMPONENTS
import { StepTitle, Content, Footer } from "~/pages/Private/Caixa/components/ModalNovoCreditoUsuario/styles";

// BUTONS
import ButtonPrimary from '~/components/Buttons/Normal/Primary';
import ButtonSecondary from '~/components/Buttons/Normal/Secondary'

// SERVICES
import APIRequests from "~/services/requests_api";

const Etapa0MigrarEndereco = ({
    data = {},
    onConfirm = async (data) => { },
    onBack = async () => { },
}) => {

    /**
     * Array de usuários localizados.
     */
    const [Endereco, setEndereco] = useState({
        ...data || {}
    });

    /**
     * Botão de avançar, está bloqueado?
     */
    const Blocked = !Endereco?.uuid;

    /**
     * Função que é disparada depois de pesquisar
     */
    const goLoadOptions = React.useCallback(
        debounce((input_value, callback) => {

            /**
             * Pega os dados da api.
             * !Não da para usar await, precisa usar o then por causa do debounce
             */
            APIRequests.enderecos.listar(
                input_value,
                1,
                30
            ).then(({ results }) => {

                /**
                 * Gera a array com os novos dados.
                 */
                const options = results.map((reg) => ({
                    label: `${reg.logradouro} , ${reg.numero}, ${reg.municipio} - ${reg.uf}, ${reg.cep}`,
                    value: reg.uuid, ...reg
                }));

                /**
                 * Executa o callback pra mostrar os dados
                 */
                callback(options);
            });

        }, 700),
        []
    );

    return (
        <Content style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
                <StepTitle>
                   Selecione um endereço
                </StepTitle>

                <Row>
                    <ColSm12>
                        <ReactAsyncSelect
                            autoFocus
                            loadOptions={goLoadOptions}

                            {...(Endereco?.uuid ? {

                                value: {
                                    value: Endereco?.value || '',
                                    label: Endereco?.label || '',
                                }

                            } : {})}

                            placeholder="Pesquise pela rua, bairro, número, complemento"

                            onChange={value => {
                                onConfirm(value)
                                setEndereco(value)
                            }}
                        />
                    </ColSm12>
                </Row>
            </div>

            <Footer>

                <ButtonSecondary onClick={onBack}>
                    Fechar
                </ButtonSecondary>

                <ButtonPrimary onClick={() => onConfirm(Endereco)} disabled={Blocked}>
                    Próxima etapa
                </ButtonPrimary>

            </Footer>
        </Content>
    )

}

export default Etapa0MigrarEndereco;